export const LOAD_KARAOKES = 'LOAD_KARAOKES'
export const ADD_KARAOKE = 'ADD_KARAOKE'
export const LOAD_KARAOKE_DISC_JOCKEYS = 'LOAD_KARAOKE_DISC_JOCKEYS'
export const ADD_KARAOKE_DISC_JOCKEYS = 'ADD_KARAOKE_DISC_JOCKEYS'
export const REMOVE_KARAOKE_DISC_JOCKEYS = 'REMOVE_KARAOKE_DISC_JOCKEYS'
export const LOAD_PARTICIPATORS = 'LOAD_PARTICIPATORS'